import { useEffect, useState } from 'react';
import Icon from '../components/Icon';
import PageHeader from '../components/PageHeader';
import { Group, Row, SectionTitle } from '../components/SettingsRows';
import { copyText, qrDataUrl, shareLink } from '../lib/coach';
import { useApp } from '../lib/AppContext';

const TOGGLE = 'toggle toggle-lg border-base-300 bg-base-300 text-white checked:border-primary checked:bg-primary checked:text-white';

// ⑨ "Mã HLV của tôi": the fixed code and its QR (it opens <site>/c/<code>), to share, print or put in a bio.
export default function CoachCodePage() {
  const { api, coach, setCoach, native, profile } = useApp();
  const [qr, setQr] = useState(null);
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [gym, setGym] = useState(coach?.gym || '');
  const url = coach ? `${native?.siteUrl || window.location.origin}/c/${coach.code}` : null;

  useEffect(() => { if (url) qrDataUrl(url).then(setQr).catch(() => setQr(null)); }, [url]);
  useEffect(() => { api.get('/coach').then((c) => { setCoach(c); setGym(c.gym || ''); }).catch(() => {}); }, [api, setCoach]);

  const save = async (attrs) => {
    setBusy(true);
    try {
      setCoach(await api.patch('/coach', attrs));
    } catch (e) {
      setStatus(e.message);
    } finally {
      setBusy(false);
    }
  };

  const rotate = async () => {
    if (!window.confirm('Đổi mã mới? Mã cũ sẽ không dùng được nữa. Học viên đã kết nối không bị ảnh hưởng.')) return;
    setBusy(true);
    try {
      setCoach(await api.post('/coach/rotate_code'));
      setStatus('Đã đổi mã mới');
    } finally {
      setBusy(false);
    }
  };

  const saveImage = () => {
    const a = document.createElement('a');
    a.href = qr;
    a.download = `ma-hlv-${coach.code}.png`;
    a.click();
  };

  if (!coach) return <PageHeader title="Mã HLV của tôi" fallback="/coach" />;
  const outline = 'btn h-12 gap-2 whitespace-nowrap rounded-[16px] border-line bg-base-100 px-3 text-[15px] font-bold';
  return (
    <div className="flex flex-col gap-4">
      <PageHeader title="Mã HLV của tôi" fallback="/coach" />
      <section className="flex flex-col items-center gap-3 rounded-[24px] bg-base-100 p-6 text-center">
        <p className="text-sm text-muted">Học viên nhập mã hoặc quét QR để kết nối với {profile?.name || 'bạn'}</p>
        <p className="tabular text-4xl font-extrabold tracking-wider">{coach.code}</p>
        {qr ? <img src={qr} alt={`Mã QR của mã HLV ${coach.code}`} className="size-60 rounded-[16px] border border-line" /> : <div className="skeleton size-60 rounded-[16px]" />}
        <p className="text-xs text-muted">Kết nối bằng mã không tốn chỗ. Học viên giữ nguyên gói của họ.</p>
      </section>
      <button type="button" className="btn btn-primary h-[54px] rounded-[16px] border-0 text-base font-bold"
        onClick={async () => setStatus((await shareLink({ title: 'Mã HLV Macro Mate', text: `Kết nối với mình trên Macro Mate, mã HLV: ${coach.code}`, url })) === 'copied' ? 'Đã sao chép link' : null)}>
        <Icon name="upload" className="size-5" /> Chia sẻ qua Zalo, Messenger…
      </button>
      <div className="grid grid-cols-2 gap-3">
        <button type="button" className={outline} disabled={!qr} onClick={saveImage}><Icon name="photo" className="size-5" /> Lưu ảnh QR</button>
        <button type="button" className={outline} onClick={async () => { await copyText(coach.code); setStatus('Đã sao chép mã'); }}>
          <Icon name="copy" className="size-5" /> Sao chép mã
        </button>
      </div>
      {status && <p role="status" className="text-center text-sm font-medium text-brand-text">{status}</p>}

      <SectionTitle>Cài đặt</SectionTitle>
      <Group>
        <Row label="Duyệt trước khi kết nối" hint="Tắt để học viên kết nối ngay khi nhập mã" htmlFor="approval">
          <input id="approval" type="checkbox" className={TOGGLE} checked={coach.approval_required} disabled={busy}
            onChange={(e) => save({ approval_required: e.target.checked })} />
        </Row>
        <form className="flex items-center gap-2 py-3" onSubmit={(e) => { e.preventDefault(); save({ gym }); }}>
          <label htmlFor="gym" className="sr-only">Phòng tập</label>
          <input id="gym" className="input h-11 flex-1 rounded-[12px] border-line text-base" placeholder="Phòng tập (học viên sẽ thấy)"
            maxLength={80} value={gym} onChange={(e) => setGym(e.target.value)} />
          <button type="submit" className="btn h-11 rounded-[12px]" disabled={busy || gym === (coach.gym || '')}>Lưu</button>
        </form>
        <button type="button" disabled={busy} className="flex min-h-14 w-full items-center gap-3 py-2 text-left" onClick={rotate}>
          <Icon name="refresh" className="size-5 shrink-0" />
          <span>
            <span className="block text-[15px] font-medium">Đổi mã mới</span>
            <span className="block text-xs text-muted">Mã cũ ngừng hoạt động, học viên đã kết nối vẫn giữ nguyên</span>
          </span>
        </button>
      </Group>
    </div>
  );
}
